import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Chat"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-chat',
    templateUrl: './icon-chat.component.html',
    styleUrls: ['./icon-chat.component.scss'],
    standalone: false
})
export class IconChatComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
